import React from 'react';
//import { Body1 } from '../components/FontStyles';
//import baseTheme from '../themes/baseTheme';

import ViewContainer from '../components/patterns/ViewContainer';
import { Link } from 'react-router-dom';
import { Headline } from '../components/FontStyles';
import settings2 from '../images/settings2.png';
import { Flex, Box } from 'rebass';

class UserSettings2 extends React.Component {
  render() {
    return (
      <ViewContainer>
        <Flex width={1} flexWrap="wrap" mt={2} justifyContent="center">
          <Flex width={1} mb={4} justifyContent="center">
            <Headline> Settings </Headline>
          </Flex>

          <Link to="/settings-3">
            <Box width={1}>
              <img alt="test" src={settings2} style={{ width: '75%' }} />
            </Box>
          </Link>
        </Flex>
      </ViewContainer>
    );
  }
}

export default UserSettings2;
